<template>
  <div class="guidePage">
    <div class="loadingBox">
      <img src="../../assets/img/robotHead.png" class="loadingImg">
      <p class="slogan">欢迎使用智旅途</p>
      <p class="slogan">AI人工智能客服支持系统</p>
      <p class="loadingMsg">连接中......</p>
    </div>
    <p class="copyright">© 2024 智旅途</p>
  </div>

</template>

<script>
export default {
  name: 'guide'
}
</script>

<style scoped>
.guidePage {
  background: #fdfdfd;
  height: 100vh;
}

.loadingBox {
  width: 100%;
  height: 200px;
  position: absolute;
  top: 0;
  bottom: 115px;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loadingMsg {
  width: 40%;
  font-size: 15px;
  text-align: center;
  margin: 0 auto;
  margin-top: 20px;
  color: #a5adbd;
}

.loadingImg {
  width: 24%;
  margin-bottom: 40px;
}

.slogan {
  font-size: 21px;
  color: #474747;
}
.copyright{
  font-size:14px;
  color: #a5adbd;
  position: absolute;
  bottom: 60px;
  text-align: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/guide.vue